module.exports = __webpack_public_path__ + "static/media/remove_icon.ed2959d9.svg";